export default __webpack_public_path__ + "d486cb60e500e0aa8e650064e68e3227.png";